<app-navbar></app-navbar>

<div class="page-not-found">
    <img src="/assets/img/page-not-found.svg" alt="Page not Found 404" />

    <h1>ERROR 404</h1>
    <h3>Lo Siento, no se encontro la página</h3>
    <p>Es posible que haya escrito la dirección incorrectamente o que haya usado un enlace desactualizado.</p>

    <a [routerLink]="['/']"><button mat-button>Volver al inicio</button></a>
</div>